import React, {Component} from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Transfer} from 'antd';
// import elements
import TagList from './Component.TagList';

class DigestEnzyme extends Component{
  constructor(props){
    super(props);
    this.state = {
      updateData: [],
      updateKeys: [],
    }
  }
  
  componentDidMount(){
    // default selected enzyme list, which is 'Trypsin'
    let chosen = this.props.parameters.enzyme.slice();
    // arguments:
    // default enzyme list
    // deafult selected value
    this.getEnzymeData(this.props.digestEnzymeList, chosen);
  }

  // take in the raw data and generate a format that can be used specifically to generate ant <Tansfer> UI
  // chosen: [] the selected enzyme list
  getEnzymeData= (enzymeData, chosen)=>{
    const updateKeys = [];
    const updateData = [];
    for (let i = 0; i < enzymeData.length; i++){
      const data = {
        key: `${enzymeData[i]["enzyme"]}`,
        title: `${enzymeData[i]["enzyme"]}`,
        description: `description of content ${enzymeData[i]["enzyme"]}`,
        chosen: chosen.indexOf(enzymeData[i]["enzyme"]) !== -1
      };
      if(data.chosen){
          updateKeys.push(data.key);
      }
      updateData.push(data);
    }
    this.setState({updateData, updateKeys});
  }

  filterOption = (inputValue, option) => {
    return option.description.indexOf(inputValue) > -1;
  }
  
  //this is a antd function to update key upon changes, takes three arguments
  handleChange = (updateKeys) => {
    this.setState({updateKeys});
    this.props.updateParameters({enzyme: updateKeys});
  }

  callback(key){
    //console.log(key);
  }

  render(){
    return (
      <div>
        <div css={css`
          font-size: 1.0rem;
          font-weight: 600;
          padding: 15px 0;
        `}>
          Select enzymes used for digestion
        </div>
        
        <Transfer
          listStyle={{
            width: '45%',
            height: 400,
          }}
          dataSource={this.state.updateData}
          showSearch
          filterOption={this.filterOption}
          targetKeys={this.state.updateKeys}
          onChange={this.handleChange}
          render={item=>item.title}>
        </Transfer>

        <TagList 
          title = "Selected enzymes used for digestion"
          color = "#108ee9"
          list = {this.state.updateKeys}
        />          
      </div>
    );
  }
}

export default DigestEnzyme;


